/*
Copyright © 2021 The Sage Group plc or its licensors. All Rights reserved
 */

/**
 * Do not edit directly
 * Generated on Fri, 04 Mar 2022 15:25:36 GMT
 */

module.exports = {
  metaName: 'Base Theme',
  metaPublic: 'true',
  colorsLogo: '#00d639ff',
  colorsTransparent: '#00000000',
  colorsYin030: '#0000004d',
  colorsYin055: '#0000008c',
  colorsYin065: '#000000a6',
  colorsYin075: '#000000bf',
  colorsYin090: '#000000e6',
  colorsYang100: '#ffffffff',
  colorsYang080: '#ffffffcc',
  colorsGray850: '#262626ff',
  colorsGray900: '#1a1a1aff',
  colorsGray1000: '#000000ff',
  colorsGray000: '#ffffffff',
  colorsDisabled400: '#f2f5f6ff',
  colorsDisabled500: '#e6ebedff',
  colorsDisabled600: '#ccd6dbff',
  colorsReadOnly400: '#f2f5f6ff',
  colorsReadOnly500: '#e6ebedff',
  colorsReadOnly600: '#ccd6dbff',
  colorsComponentsMenuSpringStandard500: '#e6ebedff',
  colorsComponentsMenuSpringStandard600: '#007e45ff',
  colorsComponentsMenuSpringStandard700: '#d9e0e4ff',
  colorsComponentsMenuSpringParent500: '#e6ebedff',
  colorsComponentsMenuSpringParent600: '#ffffffff',
  colorsComponentsMenuSpringParent700: '#d9e0e4ff',
  colorsComponentsMenuSpringChild400: '#ccd6dbff',
  colorsComponentsMenuSpringChild500: '#ffffffff',
  colorsComponentsMenuSpringChild600: '#007e45ff',
  colorsComponentsMenuSpringChildAlt500: '#e6ebedff',
  colorsComponentsMenuSpringChildAlt600: '#007e45ff',
  colorsComponentsMenuSummerStandard500: '#ffffffff',
  colorsComponentsMenuSummerStandard600: '#007e45ff',
  colorsComponentsMenuSummerStandard700: '#f2f5f6ff',
  colorsComponentsMenuSummerParent500: '#ffffffff',
  colorsComponentsMenuSummerParent600: '#e6ebedff',
  colorsComponentsMenuSummerParent700: '#f2f5f6ff',
  colorsComponentsMenuSummerChild400: '#b3c2c9ff',
  colorsComponentsMenuSummerChild500: '#e6ebedff',
  colorsComponentsMenuSummerChild600: '#007e45ff',
  colorsComponentsMenuSummerChildAlt500: '#ccd6dbff',
  colorsComponentsMenuSummerChildAlt600: '#007e45ff',
  colorsComponentsMenuAutumnStandard500: '#00324cff',
  colorsComponentsMenuAutumnStandard600: '#007e45ff',
  colorsComponentsMenuAutumnStandard700: '#19475eff',
  colorsComponentsMenuAutumnParent500: '#00324cff',
  colorsComponentsMenuAutumnParent600: '#001926ff',
  colorsComponentsMenuAutumnParent700: '#19475eff',
  colorsComponentsMenuAutumnChild400: '#19475eff',
  colorsComponentsMenuAutumnChild500: '#001926ff',
  colorsComponentsMenuAutumnChild600: '#007e45ff',
  colorsComponentsMenuAutumnChildAlt500: '#00324cff',
  colorsComponentsMenuAutumnChildAlt600: '#007e45ff',
  colorsComponentsMenuWinterStandard500: '#000000ff',
  colorsComponentsMenuWinterStandard600: '#007e45ff',
  colorsComponentsMenuWinterStandard700: '#262626ff',
  colorsComponentsMenuWinterParent500: '#000000ff',
  colorsComponentsMenuWinterParent600: '#000000ff',
  colorsComponentsMenuWinterParent700: '#262626ff',
  colorsComponentsMenuWinterChild400: '#262626ff',
  colorsComponentsMenuWinterChild500: '#000000ff',
  colorsComponentsMenuWinterChild600: '#007e45ff',
  colorsComponentsMenuWinterChildAlt500: '#1a1a1aff',
  colorsComponentsMenuWinterChildAlt600: '#007e45ff',
  colorsComponentsMenuYin100: '#000000ff',
  colorsComponentsMenuYin065: '#000000a6',
  colorsComponentsMenuYin090: '#000000e6',
  colorsComponentsMenuYang100: '#ffffffff',
  colorsComponentsMenuYang080: '#ffffffcc',
  colorsUtilityMajor100: '#ccd6dbff',
  colorsUtilityMajor150: '#b3c2c9ff',
  colorsUtilityMajor200: '#99adb7ff',
  colorsUtilityMajor300: '#668494ff',
  colorsUtilityMajor400: '#335b70ff',
  colorsUtilityMajor500: '#00324cff',
  colorsUtilityMajor800: '#00141eff',
  colorsUtilityMajor025: '#f2f5f6ff',
  colorsUtilityMajor010: '#fafbfbff',
  colorsUtilityMajor040: '#edf1f2ff',
  colorsUtilityMajor050: '#e6ebedff',
  colorsUtilityMajor075: '#d9e0e4ff',
  colorsUtilityMajorTransparent: '#00000000',
  colorsUtilityYin030: '#0000004d',
  colorsUtilityYin055: '#0000008c',
  colorsUtilityYin065: '#000000a6',
  colorsUtilityYin090: '#000000e6',
  colorsUtilityYang100: '#ffffffff',
  colorsUtilityDisabled400: '#f2f5f6ff',
  colorsUtilityDisabled500: '#e6ebedff',
  colorsUtilityDisabled600: '#ccd6dbff',
  colorsUtilityReadOnly400: '#f2f5f6ff',
  colorsUtilityReadOnly500: '#e6ebedff',
  colorsUtilityReadOnly600: '#ccd6dbff',
  colorsActionMajor150: '#b3d9c8ff',
  colorsActionMajor500: '#007e45ff',
  colorsActionMajor600: '#006738ff',
  colorsActionMajor700: '#004d2aff',
  colorsActionMajor025: '#f2f9f6ff',
  colorsActionMajorTransparent: '#00000000',
  colorsActionMajorYin030: '#0000004d',
  colorsActionMajorYin055: '#0000008c',
  colorsActionMajorYin065: '#000000a6',
  colorsActionMajorYin090: '#000000e6',
  colorsActionMajorYang100: '#ffffffff',
  colorsActionMinor100: '#e6ebedff',
  colorsActionMinor150: '#d9e0e4ff',
  colorsActionMinor200: '#ccd6dbff',
  colorsActionMinor250: '#b3c2c9ff',
  colorsActionMinor300: '#99adb7ff',
  colorsActionMinor400: '#668494ff',
  colorsActionMinor500: '#335b70ff',
  colorsActionMinor550: '#19475eff',
  colorsActionMinor600: '#00324cff',
  colorsActionMinor850: '#001926ff',
  colorsActionMinor900: '#00141eff',
  colorsActionMinor025: '#fafbfbff',
  colorsActionMinor050: '#f2f5f6ff',
  colorsActionMinorTransparent: '#00000000',
  colorsActionMinorYin030: '#0000004d',
  colorsActionMinorYin055: '#0000008c',
  colorsActionMinorYin065: '#000000a6',
  colorsActionMinorYin090: '#000000e6',
  colorsActionMinorYang100: '#ffffffff',
  colorsActionDisabled400: '#f2f5f6ff',
  colorsActionDisabled500: '#e6ebedff',
  colorsActionDisabled600: '#ccd6dbff',
  colorsActionReadOnly400: '#f2f5f6ff',
  colorsActionReadOnly500: '#e6ebedff',
  colorsActionReadOnly600: '#ccd6dbff',
  colorsSemanticNeutral200: '#ccd6dbff',
  colorsSemanticNeutral500: '#335b70ff',
  colorsSemanticNeutral600: '#00324cff',
  colorsSemanticNeutralTransparent: '#00000000',
  colorsSemanticNeutralYin030: '#0000004d',
  colorsSemanticNeutralYin055: '#0000008c',
  colorsSemanticNeutralYin065: '#000000a6',
  colorsSemanticNeutralYin090: '#000000e6',
  colorsSemanticNeutralYang100: '#ffffffff',
  colorsSemanticFocus250: '#ffda80ff',
  colorsSemanticFocus500: '#ffb500ff',
  colorsSemanticFocusTransparent: '#00000000',
  colorsSemanticPositive500: '#008a21ff',
  colorsSemanticPositive600: '#006e1aff',
  colorsSemanticPositiveTransparent: '#00000000',
  colorsSemanticPositiveYin030: '#0000004d',
  colorsSemanticPositiveYin055: '#0000008c',
  colorsSemanticPositiveYin065: '#000000a6',
  colorsSemanticPositiveYin090: '#000000e6',
  colorsSemanticPositiveYang100: '#ffffffff',
  colorsSemanticNegative500: '#cd384bff',
  colorsSemanticNegative600: '#a42d3cff',
  colorsSemanticNegativeTransparent: '#00000000',
  colorsSemanticNegativeYin030: '#0000004d',
  colorsSemanticNegativeYin055: '#0000008c',
  colorsSemanticNegativeYin065: '#000000a6',
  colorsSemanticNegativeYin090: '#000000e6',
  colorsSemanticNegativeYang100: '#ffffffff',
  colorsSemanticCaution400: '#f28533ff',
  colorsSemanticCaution500: '#ef6700ff',
  colorsSemanticCaution600: '#bf5200ff',
  colorsSemanticCaution650: '#a74800ff',
  colorsSemanticCautionTransparent: '#00000000',
  colorsSemanticCautionYin030: '#0000004d',
  colorsSemanticCautionYin055: '#0000008c',
  colorsSemanticCautionYin065: '#000000a6',
  colorsSemanticCautionYin090: '#000000e6',
  colorsSemanticCautionYang100: '#ffffffff',
  colorsSemanticInfo150: '#b3cfe5ff',
  colorsSemanticInfo500: '#0060a7ff',
  colorsSemanticInfo600: '#004d86ff',
  colorsSemanticInfoTransparent: '#00000000',
  colorsSemanticInfoYin030: '#0000004d',
  colorsSemanticInfoYin055: '#0000008c',
  colorsSemanticInfoYin065: '#000000a6',
  colorsSemanticInfoYin090: '#000000e6',
  colorsSemanticInfoYang100: '#ffffffff',
  sizing100: '8px',
  sizing125: '10px',
  sizing150: '12px',
  sizing175: '14px',
  sizing200: '16px',
  sizing250: '20px',
  sizing275: '22px',
  sizing300: '24px',
  sizing350: '28px',
  sizing375: '30px',
  sizing400: '32px',
  sizing450: '36px',
  sizing500: '40px',
  sizing600: '48px',
  sizing700: '56px',
  sizing800: '64px',
  sizing900: '72px',
  sizing1000: '80px',
  sizing1300: '104px',
  sizing1600: '128px',
  sizing025: '2px',
  sizing050: '4px',
  sizing075: '6px',
  sizingLogowidth: '40px',
  sizing010: '1px',
  spacing100: '8px',
  spacing125: '10px',
  spacing150: '12px',
  spacing200: '16px',
  spacing250: '20px',
  spacing300: '24px',
  spacing400: '32px',
  spacing500: '40px',
  spacing600: '48px',
  spacing700: '56px',
  spacing800: '64px',
  spacing900: '72px',
  spacing1000: '80px',
  spacing000: '0',
  spacing025: '2px',
  spacing050: '4px',
  spacing075: '6px',
  borderWidth100: '1px',
  borderWidth200: '2px',
  borderWidth300: '3px',
  borderWidth400: '4px',
  borderWidth000: '0px',
  fontSizes100: '14px',
  fontSizes200: '16px',
  fontSizes300: '18px',
  fontSizes400: '20px',
  fontSizes500: '22px',
  fontSizes600: '24px',
  fontSizes700: '32px',
  fontSizes800: '40px',
  fontSizes900: '48px',
  fontSizes1000: '56px',
  fontSizes010: '10px',
  fontSizes025: '12px',
  fontSizes050: '13px',
  boxShadow100: '0 5px 5px 0 #00141e33, 0 10px 10px 0 #00141e1a',
  boxShadow150: '0 -4px 12px 0 #00141e0d',
  boxShadow200: '0 10px 20px 0 #00141e33, 0 20px 40px 0 #00141e1a',
  boxShadow300: '0 10px 30px 0 #00141e1a, 0 30px 60px 0 #00141e1a',
  boxShadow400: '0 10px 40px 0 #00141e0a, 0 50px 80px 0 #00141e1a',
  boxShadow075: 'inset 0 6px 4px -4px #00141e0d',
  boxShadow050: '0 3px 3px 0 #00141e33, 0 2px 4px 0 #00141e26',
  fontWeights400: '400',
  fontWeights500: '500',
  fontWeights700: '700',
  lineHeights300: '100%',
  lineHeights400: '125%',
  lineHeights500: '150%',
  fontFamiliesDefault: 'Sage UI',
  fontFamiliesIos: 'San Francisco',
  fontFamiliesAndroid: 'Roboto',
  fontFamiliesOther: 'Open Sans',
  borderRadiusCircle: '50%',
  typographyAccordionTitleM: '700 20px/125% Sage UI',
  typographyAccordionSubtitleM: '400 14px/150% Sage UI',
  typographyAccordionParagraphM: '400 14px/150% Sage UI',
  typographyActionPopoverMenuItemM: '700 14px/150% Sage UI',
  typographyAnchorNavLabelM: '500 14px/150% Sage UI',
  typographyBadgeLabelM: '500 12px/150% Sage UI',
  typographyButtonLabelS: '700 14px/150% Sage UI',
  typographyButtonLabelM: '700 14px/150% Sage UI',
  typographyButtonLabelL: '700 16px/150% Sage UI',
  typographyCardSelectTitleM: '700 16px/150% Sage UI',
  typographyCardSelectSubtitleM: '500 14px/150% Sage UI',
  typographyCardSelectParagraphM: '400 14px/150% Sage UI',
  typographyDatePickerCalendarDateM: '700 14px/150% Sage UI',
  typographyDatePickerCalendarDayM: '700 14px/150% Sage UI',
  typographyDatePickerCalendarMonthM: '700 16px/125% Sage UI',
  typographyDialogTitleXs: '700 24px/125% Sage UI',
  typographyDialogTitleS: '700 24px/125% Sage UI',
  typographyDialogTitleMs: '700 24px/125% Sage UI',
  typographyDialogTitleM: '700 24px/125% Sage UI',
  typographyDialogTitleMl: '700 24px/125% Sage UI',
  typographyDialogTitleL: '700 24px/125% Sage UI',
  typographyDialogTitleXl: '700 24px/125% Sage UI',
  typographyDialogParagraphXs: '400 14px/150% Sage UI',
  typographyDialogParagraphS: '400 14px/150% Sage UI',
  typographyDialogParagraphMs: '400 14px/150% Sage UI',
  typographyDialogParagraphM: '400 14px/150% Sage UI',
  typographyDialogParagraphMl: '400 14px/150% Sage UI',
  typographyDialogParagraphL: '400 14px/150% Sage UI',
  typographyDialogParagraphXl: '400 14px/150% Sage UI',
  typographyDrawerTitleM: '700 22px/125% Sage UI',
  typographyFlashTextM: '400 14px/150% Sage UI',
  typographyFlashTextL: '400 16px/150% Sage UI',
  typographyFormFieldLabelXs: '500 14px/150% Sage UI',
  typographyFormFieldLabelS: '500 14px/150% Sage UI',
  typographyFormFieldLabelM: '500 14px/150% Sage UI',
  typographyFormFieldLabelL: '500 16px/150% Sage UI',
  typographyFormFieldHintTextXs: '400 14px/150% Sage UI',
  typographyFormFieldHintTextS: '400 14px/150% Sage UI',
  typographyFormFieldHintTextM: '400 14px/150% Sage UI',
  typographyFormFieldHintTextL: '400 16px/150% Sage UI',
  typographyFormFieldErrorMessageXs: '500 14px/150% Sage UI',
  typographyFormFieldErrorMessageS: '500 14px/150% Sage UI',
  typographyFormFieldErrorMessageM: '500 14px/150% Sage UI',
  typographyFormFieldErrorMessageL: '500 16px/150% Sage UI',
  typographyFormFieldCautionMessageXs: '400 14px/150% Sage UI',
  typographyFormFieldCautionMessageS: '400 14px/150% Sage UI',
  typographyFormFieldCautionMessageM: '400 14px/150% Sage UI',
  typographyFormFieldCautionMessageL: '400 16px/150% Sage UI',
  typographyFormFieldInputTextXs: '400 14px/150% Sage UI',
  typographyFormFieldInputTextS: '400 14px/150% Sage UI',
  typographyFormFieldInputTextM: '400 14px/150% Sage UI',
  typographyFormFieldInputTextL: '400 16px/150% Sage UI',
  typographyFormFieldDropdownOptionsXs: '400 14px/150% Sage UI',
  typographyFormFieldDropdownOptionsS: '400 14px/150% Sage UI',
  typographyFormFieldDropdownOptionsM: '400 14px/150% Sage UI',
  typographyFormFieldDropdownOptionsL: '400 16px/150% Sage UI',
  typographyFormFieldSecondLabelXs: '500 14px/150% Sage UI',
  typographyFormFieldSecondLabelS: '500 14px/150% Sage UI',
  typographyFormFieldSecondLabelM: '500 14px/150% Sage UI',
  typographyFormFieldSecondLabelL: '500 16px/150% Sage UI',
  typographyFormFieldCharacterCountXs: '400 14px/150% Sage UI',
  typographyFormFieldCharacterCountS: '400 14px/150% Sage UI',
  typographyFormFieldCharacterCountM: '400 14px/150% Sage UI',
  typographyFormFieldCharacterCountL: '400 16px/150% Sage UI',
  typographyLinkTextM: '400 14px/150% Sage UI',
  typographyLinkTextL: '400 16px/150% Sage UI',
  typographyMenuLabelM: '500 14px/150% Sage UI',
  typographyMenuSegmentTitleM: '500 12px/150% Sage UI',
  typographyMessageHeadingM: '700 14px/150% Sage UI',
  typographyMessageHeadingL: '700 16px/150% Sage UI',
  typographyMessageTextM: '400 14px/150% Sage UI',
  typographyMessageTextL: '400 16px/150% Sage UI',
  typographyPaginationLabelM: '400 13px/150% Sage UI',
  typographyPillLabelS: '500 10px/150% Sage UI',
  typographyPillLabelM: '500 12px/150% Sage UI',
  typographyPillLabelL: '500 14px/150% Sage UI',
  typographyPillLabelXl: '500 16px/150% Sage UI',
  typographyProfileEmailXs: '400 12px/100% Sage UI',
  typographyProfileEmailS: '400 14px/100% Sage UI',
  typographyProfileEmailM: '400 14px/125% Sage UI',
  typographyProfileEmailMl: '400 14px/125% Sage UI',
  typographyProfileEmailL: '400 14px/125% Sage UI',
  typographyProfileEmailXl: '400 18px/125% Sage UI',
  typographyProfileEmailXxl: '400 24px/125% Sage UI',
  typographyProfileInitialsXs: '500 10px/150% Sage UI',
  typographyProfileInitialsS: '500 14px/150% Sage UI',
  typographyProfileInitialsM: '500 18px/150% Sage UI',
  typographyProfileInitialsMl: '500 24px/150% Sage UI',
  typographyProfileInitialsL: '500 32px/150% Sage UI',
  typographyProfileInitialsXl: '500 48px/150% Sage UI',
  typographyProfileInitialsXxl: '500 56px/150% Sage UI',
  typographyProfileNameXs: '500 13px/100% Sage UI',
  typographyProfileNameS: '500 14px/100% Sage UI',
  typographyProfileNameM: '500 14px/125% Sage UI',
  typographyProfileNameMl: '500 16px/125% Sage UI',
  typographyProfileNameL: '500 20px/125% Sage UI',
  typographyProfileNameXl: '500 24px/125% Sage UI',
  typographyProfileNameXxl: '500 32px/125% Sage UI',
  typographyProgressTrackerValueLabelS: '500 14px/150% Sage UI',
  typographyProgressTrackerValueLabelM: '500 14px/150% Sage UI',
  typographyProgressTrackerValueLabelL: '500 14px/150% Sage UI',
  typographySearchLabelM: '400 14px/150% Sage UI',
  typographySidebarTitleS: '700 20px/125% Sage UI',
  typographySidebarTitleM: '700 20px/125% Sage UI',
  typographySidebarTitleL: '700 20px/125% Sage UI',
  typographyStepFlowCompleteLabelM: '500 14px/150% Sage UI',
  typographyStepFlowCurrentLabelM: '500 14px/150% Sage UI',
  typographyStepFlowIncompleteLabelM: '500 14px/150% Sage UI',
  typographySwitchOptionLabelM: '500 12px/150% Sage UI',
  typographySwitchOptionLabelL: '500 14px/150% Sage UI',
  typographyTableHeaderTextM: '500 14px/150% Sage UI',
  typographyTableCellTextM: '400 14px/150% Sage UI',
  typographyTooltipTextM: '400 14px/150% Sage UI',
  typographyTooltipTextL: '400 16px/150% Sage UI',
  opacity300: '0.3',
  opacity600: '0.6',
  opacity800: '0.8'
}
